module.exports = __webpack_public_path__ + "fonts/Barlow-Thin.3ec4465.woff2";